import { render, staticRenderFns } from "./ultra-t1.vue?vue&type=template&id=7bcb441b&scoped=true"
import script from "./ultra-t1.vue?vue&type=script&lang=js"
export * from "./ultra-t1.vue?vue&type=script&lang=js"
import style0 from "./ultra-t1.vue?vue&type=style&index=0&id=7bcb441b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb441b",
  null
  
)

export default component.exports